import AddressUpdateInterface from "@app/Interface/AddressUpdateInterface";

export default class AddressUpdateModel implements AddressUpdateInterface {
    fpuID: number;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    addressType: string;
    
    constructor() {
        this.fpuID = 0;
        this.address1 = "";
        this.address2 = "";
        this.city = "";
        this.state = "";
        this.zip = "";
        this.addressType = "";
    }

}